import { Component, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExportService } from '@app/shared/services/export.service';
export interface AddCommentsDialogData {
  record?: any;
  isCancelRow?: boolean;
  // Download confirmation
  count?: number;
  option?: string; // 'download' | 'confirmation' | other
  selectedCard?: string | null;
  selectedRows?: any[];
  columns?: any[];
  // Generic confirmation message
  content?: string;
}

@Component({
  selector: 'app-add-comments',
  templateUrl: './add-comments.component.html',
  styleUrls: ['./add-comments.component.scss'],
})
export class AddCommentsComponent {
  @Output() save = new EventEmitter<string>(); // emitted when saving new comment
  @Output() cancel = new EventEmitter<void>(); // emitted when cancelling

  form!: FormGroup; // initialize later

  title: string = 'Add Comments';
  content: string = '';

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddCommentsComponent>,
    private readonly exportService: ExportService,
    @Inject(MAT_DIALOG_DATA) public data: AddCommentsDialogData,
  ) {
    this.form = this.fb.group({
      comment: ['', [Validators.required, Validators.maxLength(1000)]],
    });

    // Configure dialog based on the incoming data
    if (data?.isCancelRow) {
      this.title = 'Add Comments to Cancel';
    } else if (data?.option === 'download') {
      this.title = 'Download Report';
      const count = data.count ?? 0;
      this.content =
        data.content ??
        `You have selected ${count} profiles. \n Do you want to proceed with the download?`;
    } else if (data?.option === 'confirmation') {
      this.title = 'Confirmation';
      this.content =
        data.content ?? 'Are you sure you want to proceed with this action?';
    }
  }

  onCancel(): void {
    this.cancel.emit();
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.form.valid) {
      const value = this.form.value.comment.trim();
      this.save.emit(value);
      this.dialogRef.close(value);
      this.form.reset();
    } else {
      this.form.markAllAsTouched();
    }
  }

  onDownload() {
    const fileName = `${this.data.selectedCard || 'asset-management'}-data`;
    this.exportService.exportToExcel(
      this.data.selectedRows || [],
      this.data.columns || [],
      fileName,
      this.data.selectedCard?.toString(),
    );
    this.dialogRef.close(true);
  }

  // Simple confirmation (used when option === 'confirmation')
  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
